var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthorCommentsCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "author-???") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "author-???",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20 20 0 20 0 0 20 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375,10 C17.375,12.2615605 16.3570413,14.285364 14.7543254,15.6382089 L16.4911165,17.375 L10,17.375 C7.96344999,17.375 6.11969999,16.549525 4.78508749,15.2149125 C3.45047499,13.8803 2.625,12.03655 2.625,10 C2.625,7.96344999 3.45047499,6.11969999 4.78508749,4.78508749 C6.11969999,3.45047499 7.96344999,2.625 10,2.625 C12.03655,2.625 13.8803,3.45047499 15.2149125,4.78508749 C16.549525,6.11969999 17.375,7.96344999 17.375,10 Z",
    id: "Combined-Shape",
    stroke: "#062B75",
    strokeWidth: 1.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorCommentsCount);
export default __webpack_public_path__ + "static/media/author-comments-count.419c40ee.svg";
export { ForwardRef as ReactComponent };